import { createClient} from "../http-client";
import { AxiosInstance, AxiosResponse } from 'axios';
import { prefixBaseUrlOneApi, getBaseUrlOneApi } from "@/helper";


export class CityZipCodeService{

    constructor(private client : AxiosInstance) {
        this.client = client;
    }

    async getById(id: number): Promise<AxiosResponse> {
        return await this.client.get(prefixBaseUrlOneApi + "/cityzipcodes/" + id, { baseURL: getBaseUrlOneApi() });
    }

    async getAll(): Promise<AxiosResponse> {
        return await this.client.get(prefixBaseUrlOneApi + "/cityzipcodes", { baseURL: getBaseUrlOneApi() });
    }

    async zip(zipCode: string): Promise<AxiosResponse> {
        return await this.client.get(prefixBaseUrlOneApi + "/cityzipcodes/zipcode/" + zipCode, { baseURL: getBaseUrlOneApi() });
    }

    async locations(text: string): Promise<AxiosResponse> {
        return await this.client.get(prefixBaseUrlOneApi + '/kandidaten/zipCode/locations?text=' + encodeURIComponent(text))
    }
}

export async function createCityZipCodeService(app): Promise<CityZipCodeService> {
    const client = await createClient(app);
    return new CityZipCodeService(client);
}
